import { Breakpoints, styled } from "@vw-marketing/us-components";

import { VWTheme } from "../../../shared/typings/vw-theme";

interface StyledGenericProps {
  theme: VWTheme;
}

export const StyledSubscriptionCardWrapper: any = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
`;

export const StyledSubscriptionCardInformationWrapper: any = styled.div`
  ${({ theme }: StyledGenericProps) => {
    return `
      align-items: flex-start;
      align-self: stretch;
      background: ${theme.colors.background.primary};
      border-radius: 12px;
      border: 0.5px solid ${theme.colors.border.default};
      display: flex;
      flex-direction: column;
      gap: 4px;
      padding: ${theme.size.static250} ${theme.size.static350};

      @media (min-width: ${Breakpoints.b560}px) {
        gap: ${theme.size.static100};
        padding: ${theme.size.static300} ${theme.size.static350};
      }

      @media (min-width: ${Breakpoints.b1920}px) {
        gap: ${theme.size.static150};
      }
    `;
  }}
`;
